import { render, staticRenderFns } from "./TrustsChanged.vue?vue&type=template&id=6e1581a0"
import script from "./TrustsChanged.vue?vue&type=script&lang=js"
export * from "./TrustsChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports